// extracted by mini-css-extract-plugin
module.exports = {"channelBreakdownTable":"styles_channelBreakdownTable__1dyhz"};